"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return ["que ", "como", "e", "nem", "se", "caso", "conforme", "consoante", "porque", "pois", "segundo ", "enquanto", "embora", "conquanto", "quanto menos", "quanto mais", "quando", "mal ", "apenas", "ora", "seja", "quer", "já", "logo", "portanto", "por isso", "pois", "рог conseguinte", "ou seja ", "isto é", "quer dizer", "a saber", "ou melhor", "mas", "também", "sim", "porém", "contudo", "senão", "todavia", "mas ainda", "no entanto", "entretanto"];
};